export var DEFAULT_LOAD_CONFIG_MENU_FILE_REQUEST_URL = '/datastorage/file';
export var DEFAULT_LOAD_MENU_REQUEST_ENDPOINT = '/menu/getMainMenu';
export var ROOT_APP_NAMESPACE = 'suppliers';
